import { alpha, Typography, useTheme } from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import * as React from "react";
import type { JSX } from "react";
import type { Palette } from "@mui/material/styles";

export enum MessageTypes {
    SUCCESS = "success",
    INFO = "info",
    WAITING = "waiting",
    WARNING = "warning",
    ERROR = "error",
}

// Takes the live theme palette so the colors follow the active color mode reactively.
const getStatusColor = (type: MessageTypes, palette: Palette): string => {
    const colors: Record<MessageTypes, string> = {
        [MessageTypes.SUCCESS]: palette.approvedGreen.main,
        [MessageTypes.WAITING]: alpha(palette.ink.main, 0.3),
        [MessageTypes.INFO]: alpha(palette.ink.main, 0.3),
        [MessageTypes.WARNING]: palette.merigold.text,
        [MessageTypes.ERROR]: palette.warningRed.main,
    };
    return colors[type];
};

interface IProps {
    type: "success" | "info" | "waiting" | "warning" | "error";
    textlineOne: string | JSX.Element;
    textlineTwo?: string | JSX.Element;
    btnCalback?: () => void;
    customIcon?: JSX.Element;
    style?: React.CSSProperties;
}

const getIcon = (type: MessageTypes, palette: Palette) => {
    switch (type) {
        case MessageTypes.SUCCESS:
            return <VerifiedIcon sx={{ color: getStatusColor(type, palette) }} fontSize="large" />;

        case MessageTypes.WAITING:
            return <AccessTimeFilledIcon sx={{ color: getStatusColor(type, palette) }} fontSize="large" />;

        case MessageTypes.INFO:
            return <NewReleasesIcon sx={{ color: getStatusColor(type, palette) }} fontSize="large" />;

        case MessageTypes.WARNING:
            return <NewReleasesIcon sx={{ color: getStatusColor(type, palette) }} fontSize="large" />;

        case MessageTypes.ERROR:
            return <NewReleasesIcon sx={{ color: getStatusColor(type, palette) }} fontSize="large" />;
        default:
            return undefined;
    }
};

const StatusIconTextNotification = ({ type, textlineOne, textlineTwo, btnCalback, customIcon, style }: IProps) => {
    const { palette } = useTheme();
    return (
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", boxSizing: "border-box", padding: "10px 0px", ...style }}>
            {customIcon
                ? React.cloneElement(customIcon, {
                      ...customIcon.props,
                      fontSize: "large",
                      sx: { ...customIcon.props?.sx, color: getStatusColor(MessageTypes[type.toUpperCase()], palette) },
                  })
                : getIcon(MessageTypes[type.toUpperCase()], palette)}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: btnCalback && "pointer",
                    boxSizing: "border-box",
                    paddingLeft: "10px",
                }}
                onClick={btnCalback}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 700,
                    }}
                >
                    {textlineOne}
                </Typography>
                {textlineTwo && (
                    <Typography
                        variant="body2"
                        sx={{
                            fontWeight: 700,
                        }}
                    >
                        {textlineTwo}
                    </Typography>
                )}
            </div>
        </div>
    );
};

export default StatusIconTextNotification;
